import React, { FC, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Wrapper, StyledListItem } from "./styled";
import { getFromLocalStorage } from "../../lib/utils";

const mockMenuOptions = [
  {
    title: "Общие сведения",
    nameForClick: "GeneralInformation",
  },
  {
    title: "Обследования",
    nameForClick: "Surveys",
  }
];

const LeftMenu: FC<{ handleMenuItem: (menuItem: string) => void }> = ({
  handleMenuItem,
}) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState(
    getFromLocalStorage("menuItem")
  );

  const handleSelectMenuItem = (item: string) => {
    setSelectedMenuItem(item);
    handleMenuItem(item);
  };

  return (
    <Wrapper>
      {mockMenuOptions.map((option) => (
        <MenuItem
          key={option.title}
          onClick={() => handleSelectMenuItem(option.nameForClick)}
          selected={selectedMenuItem === option.nameForClick}
        >
          <StyledListItem>{option.title}</StyledListItem>
        </MenuItem>
      ))}
    </Wrapper>
  );
};

export default LeftMenu;
